import React from "react";
import { SECTIONS } from '../../config/sections';
import { useLanguage } from '../../i18n/LanguageContext';
import '../static/Anthology.css';
import bookImage from "../images/book.png";
import anthologyImage from "../pdf/SBI7Anthology.pdf"

const Anthology = () => {
    const { t } = useLanguage();

    return (
        <section className=' projectsSection' id={SECTIONS.ANTHOLOGY} >
        <div className="anthologySummary">
            <div className="d-flex justify-content-center">
                <h2 className='siteHeadings'>{t('anthology.heading')}</h2>
            </div>
            <div id='book'>
                <a href={anthologyImage} target="_blank" rel="noopener noreferrer">
                    <img src={bookImage} alt="SBI 7.0 Anthology" loading="lazy"/>
                </a>
            </div>
            <div className="book-caption-center">
                <p><strong>{t('anthology.clickCaption')}</strong></p>
            </div>
            <div id="bot-margin">
                <p>{t('anthology.description1')}</p>
            </div>
            <div className="book-caption-center">
                <p style={{textAlign:"center", fontStyle: "italic"}}>{t('anthology.verse')}</p>
            </div>
                <div id="bot-margin">
                    <p>{t('anthology.description2')}</p>
                </div>
                <div className="book-caption-center">
                    <p style={{textAlign:"center", fontStyle: "italic"}}><strong>{t('anthology.directors')}<br /> {t('anthology.directorsNames')}</strong></p>
                </div>

        </div>
        </section>
    );
}

export default Anthology;
